import { render } from "./CargaSemana.vue?vue&type=template&id=07c04506&scoped=true"
import script from "./CargaSemana.vue?vue&type=script&lang=js"
export * from "./CargaSemana.vue?vue&type=script&lang=js"

import "./CargaSemana.vue?vue&type=style&index=0&id=07c04506&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c04506"]])

export default __exports__